import { Alert } from '@change/ds-core-ui';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { useFreePromotionFulfillment } from './hooks/useFreePromotionFulfillment';

type Props = {
	onDismiss?: () => void;
};

export function FreePromotionFulfillment({ onDismiss }: Props) {
	const { data, actions } = useFreePromotionFulfillment({ onDismiss });

	return (
		<div className="flex h-full w-full gap-4 p-6 pb-0" data-qa="free-promotion-fulfillment-section-message">
			<Alert
				className="[&>div>div]:flex-row"
				variant="info"
				{...(onDismiss && {
					onDismissClick: actions.handleDismiss,
					dismissButtonAriaLabel: 'Close free promotion fulfillment notification',
				})}
				heading={
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.title"
						replacements={{ numSignatures: data.signaturesLocalized }}
						count={data.signatures}
					/>
				}
			>
				<Translate value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.body" />
			</Alert>
		</div>
	);
}
